import { render, staticRenderFns } from "./MiniHorarios.vue?vue&type=template&id=0c2ada55&"
import script from "./MiniHorarios.vue?vue&type=script&lang=js&"
export * from "./MiniHorarios.vue?vue&type=script&lang=js&"
import style0 from "./MiniHorarios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports